import React from 'react';
import { useSelector } from 'react-redux';
import { Box, Grid } from '@mui/material';

import * as AppConstants from '../../../app/AppConstants';

function UserInfoPanel(props) {
  const appState = useSelector((state)=>state.app);

  const details = [
    {
      value: getUserType(appState) + ' Name: ' + (appState.me.netid?.fullName ?? 'N/A'),
      style: {wordWrap: 'break-word'}
    },
    {
      value: '中文姓名: ' + (appState.me.netid?.chineseName ?? appState.me.userUpstream?.chineseName ?? 'N/A'),
      style: null
    },
    {
      value: getUserType(appState) + ' ID: ' + (appState.me.user?.userId ?? 'N/A'),
      style: null
    },
    {
      value: 'Department: ' + (appState.me.netid?.department ?? 'N/A'),
      style: null
    },
    {
      value: 'Type: ' + (appState.me.userMode ? appState.me.userMode + ' ' : '') + (appState.me.user?.userType ?? 'N/A'),
      style: null
    },
    {
      value: 'Email: ' + (appState.me.netid?.email ?? 'N/A'),
      style: {whiteSpace: 'nowrap'}
    },
  ]

  return (
    <Box maxWidth="lg" sx={{ margin: "0 auto" }}>
      <Grid container spacing={2} columns={{ xs: 1, sm: 8, md: 12 }}>
        {
          details.map((detail, i) => (
            <Grid key={i} item xs={1} sm={4} md={4} style={detail.style}>
              {detail.value}
            </Grid>
          ))
        }
      </Grid>
    </Box>
  );
}

export function getUserType(appState) {
  return appState.me.user?.userType ?? AppConstants.USER_TYPE.STAFF.NAME + '/' + AppConstants.USER_TYPE.STUDENT.NAME;
}

export function getAdminDept(appState) {
  return appState.me.user?.userType === AppConstants.USER_TYPE.STAFF.NAME ? 'Human Resources Office'
  : appState.me.user?.userType === AppConstants.USER_TYPE.STUDENT.NAME ? 'Academic Registry'
  : 'Human Resources Office/Academic Registry';
}

export function getAdminOffice(appState) {
  return appState.me.user?.userType === AppConstants.USER_TYPE.STAFF.NAME ? 'Human Resources Office [Location: 13/F, Li Ka Shing Tower; Office Hours: Mon – Fri : 8:45 am – 5:30 pm]'
  : appState.me.user?.userType === AppConstants.USER_TYPE.STUDENT.NAME ? 'Academic Registry Service Centre [Room M101, Li Ka Shing Tower; Office Hours: Mon – Fri : 8:45 am – 5:30 pm]'
  : 'Human Resources Office/Academic Registry Service Centre';
}

export function getAdminOfficeCentre(appState) {
  return appState.me.user?.userType === AppConstants.USER_TYPE.STAFF.NAME ? 'Human Resources Office'
  : appState.me.user?.userType === AppConstants.USER_TYPE.STUDENT.NAME ? 'Academic Registry Service Centre'
  : 'Human Resources Office/Academic Registry Service Centre';
}

export function getPaymentCounter(appState) {
  return appState.me.user?.userType === AppConstants.USER_TYPE.STAFF.NAME ? ' [Location: 13/F, Li Ka Shing Tower; Office Hours: Mon – Fri : 8:45 am – 5:30 pm]'
  : appState.me.user?.userType === AppConstants.USER_TYPE.STUDENT.NAME ? ' of the Finance Office [Location: Room VA205, Shaw Amenities Building; Office Hours: Mon – Fri : 8:45 am – 5:35 pm]'
  : '';
}

export function getAdminOfficeUrl(appState) {
  return appState.me.user?.userType === AppConstants.USER_TYPE.STAFF.NAME ? null
  : appState.me.user?.userType === AppConstants.USER_TYPE.STUDENT.NAME ? 'https://www.polyu.edu.hk/ar/about-ar/contact-us/'
  : null;
}

export function getPaymentCounterUrl(appState) {
  return appState.me.user?.userType === AppConstants.USER_TYPE.STAFF.NAME ? null
  : appState.me.user?.userType === AppConstants.USER_TYPE.STUDENT.NAME ? 'https://www.polyu.edu.hk/fo/about-fo/opening-hours/'
  : null;
}

export function getFormARUrl(appState) {
  return appState.me.user?.userType === AppConstants.USER_TYPE.STAFF.NAME ? null
  : appState.me.user?.userType === AppConstants.USER_TYPE.STUDENT.NAME ? 'https://www.polyu.edu.hk/ar/students-in-taught-programmes/application-forms/'
  : null;
}

export default UserInfoPanel;